import React from 'react';
import { motion } from 'framer-motion';
export interface Option {
  id: string;
  emoji: string;
  text: string;
}
interface QuestionScreenProps {
  question: string;
  options: Option[];
  selectedOptionId?: string;
  onSelect: (id: string) => void;
}
export function QuestionScreen({
  question,
  options,
  selectedOptionId,
  onSelect
}: QuestionScreenProps) {
  return <div className="flex flex-col flex-grow bg-gradient-to-b from-[#fff7ed] via-rose-50/40 to-amber-50/60 px-5 pt-8 pb-10 max-w-md mx-auto w-full relative overflow-hidden" data-id="element-45">
      {/* Soft decorative blobs */}
      <div className="absolute -top-16 -right-16 w-48 h-48 bg-rose-200/40 rounded-full blur-3xl pointer-events-none" data-id="element-46" />
      <div className="absolute bottom-10 -left-16 w-48 h-48 bg-amber-200/40 rounded-full blur-3xl pointer-events-none" data-id="element-47" />

      <div className="relative z-10 flex-grow flex flex-col" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: 0.05
      }} className="mb-8" data-id="element-49">
          <h2 className="font-display font-black text-rose-950 text-[26px] leading-[1.15] tracking-tight" data-id="element-50">
            {question}
          </h2>
          <div className="mt-3 h-1 w-12 bg-gradient-to-r from-rose-500 to-amber-400 rounded-full" data-id="element-51" />
        </motion.div>

        <div className="flex flex-col gap-3.5 flex-grow" data-id="element-52">
          {options.map((option, index) => {
          const isSelected = selectedOptionId === option.id;
          const letter = String.fromCharCode(65 + index); // A, B, C
          return <motion.button key={option.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.35,
            delay: 0.1 + index * 0.08,
            ease: [0.22, 1, 0.36, 1]
          }} whileTap={{
            scale: 0.97
          }} onClick={() => onSelect(option.id)} disabled={!!selectedOptionId} className={`group relative flex items-center gap-4 p-4 rounded-2xl text-left transition-all duration-200 border-2 ${isSelected ? 'bg-gradient-to-br from-rose-500 to-pink-500 border-rose-500 shadow-[0_12px_28px_-6px_rgba(244,63,94,0.55)] scale-[1.02]' : 'bg-white border-rose-100 shadow-sm hover:shadow-md hover:border-rose-300 hover:-translate-y-0.5'}`} data-id="element-53">
                {/* Letter badge */}
                <div className={`flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center font-black text-base transition-colors ${isSelected ? 'bg-white text-rose-600' : 'bg-rose-50 text-rose-600 group-hover:bg-rose-100'}`} data-id="element-54">
                  {letter}
                </div>

                {/* Emoji */}
                <span className="text-3xl flex-shrink-0 drop-shadow-sm" data-id="element-55">
                  {option.emoji}
                </span>

                {/* Text */}
                <span className={`text-[14px] font-semibold leading-snug flex-grow ${isSelected ? 'text-white' : 'text-rose-950'}`} data-id="element-56">
                  {option.text}
                </span>

                {/* Arrow indicator */}
                <div className={`flex-shrink-0 transition-all ${isSelected ? 'text-white translate-x-0 opacity-100' : 'text-rose-400 -translate-x-1 opacity-0 group-hover:opacity-100 group-hover:translate-x-0'}`} data-id="element-57">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-58">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" data-id="element-59" />
                  </svg>
                </div>
              </motion.button>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.5
      }} className="text-center text-[11px] font-semibold text-rose-900/55 mt-8" data-id="element-60">
          Tocá una opción para continuar →
        </motion.p>
      </div>
    </div>;
}